<template>
<el-dialog title="绑定人员" :visible.sync="isShow" :append-to-body="true">
    <div class="allocate-box">
        <div class="user-list-box">
            <el-form :model="query" :inline="true" label-width="80px">
                <el-form-item>
                    <el-input v-model="query.keyword" clearable clear="searchUser" placeholder="用户名或者昵称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchUser">搜索</el-button>
                </el-form-item>
            </el-form>

            <el-table :data="userTableData" ref="userTable" @selection-change="handleUserChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="department" label="部门">
                    <template slot-scope="scope">
                        <el-link>{{scope.row.department.title}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="用户名"></el-table-column>
                <el-table-column prop="realname" label="真实姓名"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column label="商户名称">
                    <template slot-scope="scope">
                        <template v-for="(item, index) in scope.row.merchant">
                            <el-tag :key="index" :type="index % 2 === 0 ? 'primary' : 'success'" disable-transitions class="mr10">{{ item.title }}</el-tag>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="footer-box">
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 30, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        用户角色：
        <el-select v-model="query.role_id" placeholder="请选择" class="mr10">
            <el-option v-for="item in roleList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
        </el-select>
        <el-button type="primary" @click="addSaleman">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
export default {
    props: {
        parent: {}
    },
    data() {
        return {
            isShow: false,
            hotel_id: 0,
            userTableData: [],
            // 弹框搜索
            query: {
                hotel_id: "",
                keyword: "",
                role_id: ""
            },
            // tree 默认节点
            tree: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            staffs: [],
            roleList: [{
                id: '0',
                title: '销售',
            }, {
                id: '1',
                title: '管理员',
            }]
        };
    },
    created() {

    },
    methods: {
        show(hotelId) {
            let _this =this;
            _this.query = Object.assign({}, this.query)
            _this.hotel_id = hotelId;
            _this.query.keyword = "";
            _this.isShow = true;

            _this.getTableData();
        },
        // tree 获取部门下的所有员工
        getDepartmentUserList(e) {
            let that = this;
            let url = '/api/ucenter.user/getDepartmentUserList';
            let query = {
                id: e.id
            };
            // 添加或编辑客资信息
            that.$post(url, query).then(function (response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.userTableData = response.data.list;

                }
            });
        },
        searchUser() {
            let _this = this;
            if (_this.query.keyword == '') {
                this.$message({
                    message: "请输入用户名或者昵称",
                    showClose: true
                });
                return false
            }
            this.pagination.page = 1;
            _this.getTableData();

        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/merchant.user/index';
            // 添加或编辑客资信息
            let query = this.query;
            query['pagination'] = this.pagination;
            _this.$post(url, query).then(function (response) {
                if (response.code != '200') {
                    _this.$message.error(response.msg);
                } else {
                    _this.userTableData = response.data.list;
                    _this.pagination = response.data.pagination;
                    _this.loading = false;

                }
            });
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        // 列表复选框选中状态
        handleUserChange(e) {
            let ids = [];
            e.forEach((row) => {
                ids.push(row.id);
            });
            this.staffs = ids;
        },
        // 新增销售
        addSaleman() {
            let _this = this;
            if (_this.staffs.length == 0) {
                _this.$message({
                    type: 'danger',
                    message: "请选中人员"
                });
                return false
            }
            if (_this.query.role_id == "") {
                _this.$message({
                    type: 'danger',
                    message: "请选中用户角色"
                });
                return false
            }

            let url = '/api/merchant.user/bindCompanyUser';
            this.$post(url, {
                user_ids: _this.staffs,
                hotel_id: _this.hotel_id,
                role: _this.query.role_id
            }).then(res => {
                _this.isShow = false;
                _this.parent.getBindedStaff(_this.hotel_id);
                this.$message({
                    type: 'success',
                    message: res.msg
                });
            });
        },

    }
}
</script>

<style lang="less" scoped>
.allocate-box {
    display: flex;
    height: 45vh;
    overflow: auto;

    .department-tree {
        flex: 0 30%;
        border-right: 1px solid #dedede;
        overflow: auto;
    }

    .user-list-box {
        flex: 1;
        padding: 0 20px;
        overflow-y: auto;
    }
}

.mr10 {
    margin-right: 10px;
}

.el-tag--small {
    height: auto;
    white-space: normal;
    margin-bottom: 5px;
}
</style>
